import * as React from "react";
import { Component } from "react";
import { Table } from "react-bootstrap";
import { TIMEOUT } from "src/global";
import ExtendedAnnualSummaryByMonthRow from "./ExtendedAnnualSummaryByMonthRow";
import {
  IExtendedAnnualSummaryByMonthProps,
  IExtendedAnnualSummaryByMonthState,
} from "./interfaces";

export default class ExtendedAnnualSummaryByMonth extends Component<
  IExtendedAnnualSummaryByMonthProps,
  IExtendedAnnualSummaryByMonthState
> {
  public constructor(props: IExtendedAnnualSummaryByMonthProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    return (
      <Table striped={true}>
        <colgroup>
          <col width="110" />
          <col width="110" />
          <col width="110" />
        </colgroup>
        <thead>
          <tr style={{ border: "1px solid silver" }}>
            <th colSpan={20}>Extended Summary by Month: {this.props.projectLocation}</th>
          </tr>
          <tr>
            <th>Statement Date</th>
            <th>Service Start</th>
            <th>Service End</th>
            <th>Number of Days Calculated</th>
            <th>Total from Grid</th>
            <th>On-Peak from Grid</th>
            <th>Off-Peak from Grid</th>
            <th>Total Solar Generated</th>
            <th>On-Peak Credited</th>
            <th>Off-Peak Credited</th>
            <th>Last Month On-Peak Credited</th>
            <th>Last Month Off-Peak Credited</th>
            <th>Net Off-Peak Electricity</th>
            <th>Net On-Peak Electricity</th>
            <th>Net Electricity (not on bill)</th>
            <th>Net Grid Usage</th>
            <th>Solar Directly Used</th>
            <th>Total Household Usage</th>
            <th>Percent HH Usage Generated</th>
            <th>Electric Bill Amount</th>
          </tr>
        </thead>
        <tbody>
          {this.props.annualSummaryByMonth.map(summary => (
            <ExtendedAnnualSummaryByMonthRow annualSummaryRow={summary} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th style={{ textAlign: "center" }}>{this.props.annualSummaryTotals.numberOfDays}</th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.totalDelivered}</th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.onPeakFromGrid}</th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.offPeakFromGrid}</th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.totalSolarGenerated}
            </th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.onPeakGenerated}</th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.offPeakGenerated}
            </th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.lastMonthOnPeakCredits}
            </th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.lastMonthOffPeakCredits}
            </th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.netOffPeakElectricity}
            </th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.netOnPeakElectricity}
            </th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.netElectricity}</th>
            <th style={{ textAlign: "right" }}>{this.props.annualSummaryTotals.netGridUsage}</th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.solarDirectlyUsed}
            </th>
            <th style={{ textAlign: "right" }}>
              {this.props.annualSummaryTotals.totalHouseholdUsage}
            </th>
            <th>&nbsp;</th>
            <th style={{ textAlign: "right" }}>
              ${this.props.annualSummaryTotals.electricBillAmount.toFixed(2)}
            </th>
          </tr>
        </tfoot>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/reports/extendedannualsummary/ExtendedAnnualSummaryByMonth.tsx